<template>
    <div class="w-100 mw-100">
        <template v-if="dto.commonCta">
            <generic-button-cta
                css-classes="w-100 mw-100 btn-primary"
                :dto-from-object="dto.commonCta"
                :is-disabled="isDisabled"
            />
        </template>
        <template v-else-if="dto.mobileCta">
            <offer-cta-with-device-popin
                v-if="dto.mobileCta.popinWithDeviceDto"
                class="mb-2"
                additional-classes="w-100 mw-100"
                :is-primary="true"
                :label="dto.mobileCta.label"
                :offer-name="dto.name"
                :popin-id="'addOfferWithDevicePopIn'"
                :popin-ctas-dto="dto.mobileCta.popinWithDeviceDto"
                :tracking-category="'reprise_panier'"
                :tracking-label="'vers_popin'"
            />
            <ob1-boutons
                v-else
                :is-button="false"
                :is-primary="true"
                :is-wide="true"
                :is-disabled="isDisabled"
                :label="dto.mobileCta.label"
                :href="dto.mobileCta.link"
            />
        </template>
    </div>
</template>

<script>
import GenericButtonCta from "../../broadband/components/GenericButtonCta.vue";
import OfferCtaWithDevicePopin from "../../../fmfmo/common/offerdetails/OfferCtaWithDevicePopin.vue";

export default {
    name: 'CartPageOrderCta',
    components: {
        GenericButtonCta,
        OfferCtaWithDevicePopin
    },
    props: {
        dto: {
            type: Object,
            required: true
        },
        isDisabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>
